import React from 'react';
import { TouchableOpacity, Text } from 'react-native';
import { fontFamily } from '../../helpers/fontFamily';

const miniButton = ({ label, onPress, type = 'default', disabled = false }) => {
  const isResume = label === 'Resume' || label === 'Restore';

  const backgroundColor = disabled
    ? 'rgba(255,255,255,0.2)'
    : isResume
    ? 'transparent'
    : type === 'highlight'
    ? '#FFD700'
    : 'transparent';

  const borderColor = isResume ? '#FFD700' : '#fff';
  const textColor = isResume ? '#FFD700' : type === 'highlight' ? '#000' : '#fff';


  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={disabled}
      style={{
        backgroundColor,
        borderWidth: 1,
        borderColor,
        padding: 5,
        borderRadius: 5,
        margin: 3,
      }}
    >
      <Text
        style={{
          color: textColor,
          fontFamily: fontFamily.font300,
          fontSize: 12,
        }}
      >
        {label}
      </Text>
    </TouchableOpacity>
  );
};

export default miniButton;
